import { copy } from '@common/loan-act/util'
import { resolveH5 } from './type'

const share = (title: string, content: string, url: string): Promise<resolveH5> => {
  return new Promise((resolve) => {
    console.log('[分享 H5]', title, content, url)
    copy(`${title}\n${content}\n猛戳这里 → ${url}`)
    resolve('h5')
  })
}

export default share